module.exports = __webpack_public_path__ + "img/featured-desktop-cta-1.84069d41.jpg";